export default __webpack_public_path__ + "static/media/eyeDark.7616d0be.svg";